module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }